module.exports = __webpack_public_path__ + "static/media/kmclogo.e09ae338.png";